import React from 'react';
import GeneTable from '../../components/gene-table';
import RiskGraph from '../../components/risk-graph';
import Collapsible from 'react-collapsible';

class Pharm_Results extends React.Component {
  render() {
    return (
      <div>
        <div className='title-margins'>
          <h2>{this.props.userName ? `${this.props.userName}'${this.props.nameEndsWithS ? '' : 's'}` : ''} Results for Pharmacogenetics</h2>
          <h5>[<a href="https://www.pharmgkb.org/">PharmGKB</a>]</h5>
        </div>
        <div className="card">
          <p>Pharmacogenetic data derived from PharmGKB. </p>
          <p>Find genotype that carries an effect allele. </p>
          <p>Learn more about the mutation from the <a href="https://www.pharmgkb.org/genotype"> Genotype Selection Interface</a> </p>
          <GeneTable tag='pharm' cols={[ 'gene'] } />
        </div>
      </div>
    )
  }
}

export default Pharm_Results;
